/**
 * @class PriceColorants
 */
export default class PriceColorants {
    /**
     * @param {String} id
     * @param {Number} prices
     * @param {String} currency
     * @param {String} currencySymbol
     * @param {String} caption
     * @param {Boolean} withVat
     * @param {Number} vats
     * @param {Boolean} visible
     */
    constructor(id, prices, currency, currencySymbol, caption, withVat, vats, visible = true) {
        this._id = id;
        this._prices = prices;
        this._currency = currency;
        this._currencySymbol = currencySymbol;
        this._caption = caption;
        this._withVat = withVat;
        this._vats = vats;
        this._visible = visible;

        if (typeof this._id !== "string") {
            throw new Error("Invalid datatype of ID - PriceColorants");
        }
    }

    /**
     * @return {String}
     */
    get id() {
        return this._id;
    }

    /**
     * @param {String} id
     */
    set id(id) {
        this._id = id;
    }

    /**
     * @return {Object}
     */
    get prices() {
        return this._prices;
    }

    /**
     * @param {Object} prices
     */
    set prices(prices) {
        this._prices = prices;
    }

    /**
     * @return {String}
     */
    get currency() {
        return this._currency;
    }

    /**
     * @param {String} currency
     */
    set currency(currency) {
        this._currency = currency;
    }

    /**
     * @return {String}
     */
    get currencySymbol() {
        return this._currencySymbol;
    }

    /**
     * @param {String} currencySymbol
     */
    set currencySymbol(currencySymbol) {
        this._currencySymbol = currencySymbol;
    }

    /**
     * @return {String}
     */
    get caption() {
        return this._caption;
    }

    /**
     * @param {String} caption
     */
    set caption(caption) {
        this._caption = caption;
    }

    /**
     * @return {Boolean}
     */
    get withVat() {
        return this._withVat;
    }

    /**
     * @param {Boolean} withVat
     */
    set withVat(withVat) {
        this._withVat = withVat;
    }

    /**
     * @return {Object}
     */
    get vats() {
        return this._vats;
    }

    /**
     * @param {Object} vats
     */
    set vats(vats) {
        this._vats = vats;
    }

    /**
     * @return {Boolean}
     */
    get visible() {
        return this._visible;
    }

    /**
     * @param {Boolean} visible
     */
    set visible(visible) {
        this._visible = visible;
    }

    /**
     * @return {String}
     */
    toString() {
        return "PriceColorants (" + this._id + ")";
    }
}
